const OWN = 'own';
const EDIT = 'edit';
const FOLLOW = 'follow';
const PRODUCT_MODE = {
  OWN,
  EDIT,
  FOLLOW,
};
export default PRODUCT_MODE;
